angular.module('am4')
.factory('contactService', function($http, apiUrl) {
    const getContact = (field, id) => {
            return $http.get(`${apiUrl}/${field}/${id}/contacts`)
            .then(function(res) {
                return res.data;
            });
        },
        setContact = (field, id, body) => {
            return $http.post(`${apiUrl}/${field}/${id}/contacts`, body)
            .then(function(res) {
                return res.data;
            });
        };

    return {
        getFacilityContact(facilityId) {
            return getContact('facilities', facilityId);
        },
        getOrganizationContact(organizationId) {
            return getContact('organizations', organizationId);
        },
        setFacilityContact(facilityId, body) {
            return setContact('facilities', facilityId, body);
        },
        setOrganizationContact(organizationId, body) {
            return setContact('organizations', organizationId, body);
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/contact.js